// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.locationWrapper__jqJ5F {
  margin-bottom: -1px;
}

.clone__e4LGd {
  display: flex;
  pointer-events: none;
  margin-left: 10px;
  margin-top: 10px;
  padding-left: 0px !important;
}

.treeItem__Lvqyp {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  padding: 8px 15px;
  min-height: 44px;
}
.treeItem__Lvqyp.locationLevel__fhytO {
  background: var(--tables-secondary-row-sub-title-surface);
}
.treeItem__Lvqyp.withOverlay__n5hp2 {
  padding: unset;
  cursor: grabbing;
}

.over__tDZlD {
  width: 100%;
  height: 44px;
  background: var(--tables-secondary-row-sub-title-surface);
  border: 1px solid var(--tables-primary-row-stroke-drag-drop);
  box-sizing: border-box;
}

.dndIconContainer__LHkwP {
  text-align: center;
  border-radius: 50%;
  padding: 5px;
  cursor: pointer;
  outline: none;
  height: 22px;
  margin-right: 8px;
}
.dndIconContainer__LHkwP:hover {
  background-color: var(--tables-secondary-row-sub-title-surface);
}

.dndIcon__eLW7g {
  cursor: grab;
  outline: none;
}

.arrowContainer__LWpxl {
  -webkit-user-select: none;
          user-select: none;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;
  outline: none;
  margin-right: 8px;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.expandIcon__mPbcF {
  transition: transform 250ms ease;
  transform: rotate(90deg);
}
.expandIcon__mPbcF path {
  stroke: var(--tables-secondary-row-sub-title-icon);
}

.closeExpandIcon__MSSKe {
  transform: rotate(-90deg);
}

.locationNameBlock__tWvS8 {
  display: flex;
  align-items: center;
}

.locationName__WrEkP {
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px;
  text-transform: uppercase;
}
.locationName__WrEkP.locationLevel__fhytO {
  text-transform: none;
  color: var(--tables-primary-row-text-main);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}

.count__l4kTt {
  position: absolute;
  top: -10px;
  right: -10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--buttons-surface);
  font-size: 12px;
  font-weight: 600;
  color: var(--buttons-text-primary);
}

.actionsIconContainer__I8eyK {
  width: 25px;
  height: 25px;
  padding: 3px;
  -webkit-user-select: none;
          user-select: none;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageLocations/components/SortableTreeItem/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,mBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kDAAA;EACA,qDAAA;EACA,iBAAA;EACA,gBAAA;AAzEF;AA2EE;EACE,yDAAA;AAzEJ;AA4EE;EACE,cAAA;EACA,gBAAA;AA1EJ;;AA8EA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,4DAAA;EACA,sBAAA;AA3EF;;AA8EA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;AA3EF;AA6EE;EACE,+DAAA;AA3EJ;;AA+EA;EACE,YAAA;EACA,aAAA;AA5EF;;AA+EA;EACE,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA5EF;;AA+EA;EACE,gCAAA;EACA,wBAAA;AA5EF;AA8EE;EACE,kDAAA;AA5EJ;;AAgFA;EACE,yBAAA;AA7EF;;AAgFA;EACE,aAAA;EACA,mBAAA;AA7EF;;AAgFA;EACE,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA7EF;AA+EE;EACE,oBAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA7EJ;;AAiFA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;AA9EF;;AAiFA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AA9EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.locationWrapper {\n  margin-bottom: -1px;\n}\n\n.clone {\n  display: flex;\n  pointer-events: none;\n  margin-left: 10px;\n  margin-top: 10px;\n  padding-left: 0px !important;\n}\n\n.treeItem {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-primary-row-surface-default);\n  padding: 8px 15px;\n  min-height: 44px;\n\n  &.locationLevel {\n    background: var(--tables-secondary-row-sub-title-surface);\n  }\n\n  &.withOverlay {\n    padding: unset;\n    cursor: grabbing;\n  }\n}\n\n.over {\n  width: 100%;\n  height: 44px;\n  background: var(--tables-secondary-row-sub-title-surface);\n  border: 1px solid var(--tables-primary-row-stroke-drag-drop);\n  box-sizing: border-box;\n}\n\n.dndIconContainer {\n  text-align: center;\n  border-radius: 50%;\n  padding: 5px;\n  cursor: pointer;\n  outline: none;\n  height: 22px;\n  margin-right: 8px;\n\n  &:hover {\n    background-color: var(--tables-secondary-row-sub-title-surface);\n  }\n}\n\n.dndIcon {\n  cursor: grab;\n  outline: none;\n}\n\n.arrowContainer {\n  user-select: none;\n  text-align: center;\n  border-radius: 50%;\n  cursor: pointer;\n  outline: none;\n  margin-right: 8px;\n  width: 25px;\n  height: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.expandIcon {\n  transition: transform 250ms ease;\n  transform: rotate(90deg);\n\n  path {\n    stroke: var(--tables-secondary-row-sub-title-icon);\n  }\n}\n\n.closeExpandIcon {\n  transform: rotate(-90deg);\n}\n\n.locationNameBlock {\n  display: flex;\n  align-items: center;\n}\n\n.locationName {\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 12px;\n  text-transform: uppercase;\n\n  &.locationLevel {\n    text-transform: none;\n    color: var(--tables-primary-row-text-main);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n  }\n}\n\n.count {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: var(--buttons-surface);\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--buttons-text-primary);\n}\n\n.actionsIconContainer {\n  width: 25px;\n  height: 25px;\n  padding: 3px;\n  user-select: none;\n  text-align: center;\n  border-radius: 50%;\n  cursor: pointer;\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"locationWrapper": `locationWrapper__jqJ5F`,
	"clone": `clone__e4LGd`,
	"treeItem": `treeItem__Lvqyp`,
	"locationLevel": `locationLevel__fhytO`,
	"withOverlay": `withOverlay__n5hp2`,
	"over": `over__tDZlD`,
	"dndIconContainer": `dndIconContainer__LHkwP`,
	"dndIcon": `dndIcon__eLW7g`,
	"arrowContainer": `arrowContainer__LWpxl`,
	"expandIcon": `expandIcon__mPbcF`,
	"closeExpandIcon": `closeExpandIcon__MSSKe`,
	"locationNameBlock": `locationNameBlock__tWvS8`,
	"locationName": `locationName__WrEkP`,
	"count": `count__l4kTt`,
	"actionsIconContainer": `actionsIconContainer__I8eyK`
};
module.exports = ___CSS_LOADER_EXPORT___;
